import { LOCATION_PALETTE } from '../../styles/colors.css';

/**
 * Utility to generate consistent colors for location areas
 * by hashing the location string.
 */

export const getLocationColor = (location: string): string => {
  if (!location || location === '—' || location === '-') return 'inherit';

  let hash = 0;
  for (let i = 0; i < location.length; i++) {
    hash = location.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % LOCATION_PALETTE.length;
  return LOCATION_PALETTE[index];
};
